import { Container } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { FaCode, FaCloud, FaCogs, FaDatabase, FaProjectDiagram, FaTools } from "react-icons/fa";
import skills from "../data/skillsData";
import "./CSS/Skills.css";
import "./CSS/Services.css";

const services = [
  {
    icon: FaProjectDiagram,
    title: "API Design & Implementation",
    description: "Design and build RESTful APIs with clear contracts, validation, and predictable behaviour.",
  },
  {
    icon: FaDatabase,
    title: "Data Modelling & Schema Evolution",
    description: "Model relational data and manage schema changes to keep systems stable under change.",
  },
  {
    icon: FaCode,
    title: "Integration & Service Boundaries",
    description: "Define boundaries between components and integrate services without hidden coupling.",
  },
  {
    icon: FaCogs,
    title: "Workflow Automation",
    description: "Automate repeatable processes and background tasks to reduce manual effort and errors.",
  },
  {
    icon: FaTools,
    title: "Containerised Delivery",
    description: "Package and run services consistently using containers for repeatable environments.",
  },
  {
    icon: FaCloud,
    title: "Reliability & Debugging",
    description: "Diagnose issues using logs and metrics, focusing on root cause and long-term fixes.",
  },
];

function Services() {
  const tools = skills.flatMap((skillCategory) => skillCategory.icons);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Services | Lee</title>
        </Helmet>
      </HelmetProvider>
      <Container fluid className="services-container">
        <div className="services-title animate__animated animate__zoomIn">
          <h3>Services</h3>
          <h4>
            ───&nbsp;&nbsp;Page <strong>03</strong>
          </h4>
        </div>
        <div className="services-content animate__animated animate__fadeIn animate__slower my-4">
          <section className="services-section">
            <div className="services-grid">
              {services.map((item) => (
                <div className="service-item" key={item.title}>
                  <item.icon className="service-icon" aria-hidden="true" />
                  <h5>{item.title}</h5>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </section>
          <section className="services-tools">
            <p className="services-tools-title">Core Tools (selected)</p>
            <div className="services-tools-grid animate__animated animate__flipInX animate_slow">
              {tools.map((icon, idx) => (
                <i key={`tool-${idx}`} className={icon.className} title={icon.title}></i>
              ))}
            </div>
          </section>
        </div>
      </Container>
    </>
  );
}

export default Services;
